<div class="wt-plans">
  <div class="wt-plans__head">
    <div>
      <div class="wt-plans__title">Előre jelzett távollét</div>
      <div class="wt-plans__sub">Pl. „péntekenként 8–12 nem leszek". Az aznapi bejegyzés mindig felülírja.</div>
    </div>
    <span class="wt-plans__spacer"></span>
    <button type="button" class="wt-btn-cancel" *ngIf="!formOpen" (click)="openForm()">+ Új távollét</button>
  </div>

  <div class="wt-plans__form" *ngIf="formOpen">
    <div class="wt-type-chips">
      <button type="button" class="wt-type-chip" [class.wt-type-chip--active]="mode === 'weekly'" (click)="mode = 'weekly'">Hetente</button>
      <button type="button" class="wt-type-chip" [class.wt-type-chip--active]="mode === 'once'" (click)="mode = 'once'">Egyszeri</button>
    </div>

    <div class="wt-plans__grid">
      <div *ngIf="mode === 'weekly'">
        <div class="wt-field__label">Nap</div>
        <select class="wt-field__input" [(ngModel)]="weekday">
          <option *ngFor="let d of dayNames; let i = index" [ngValue]="i + 1">{{ d }}</option>
        </select>
      </div>
      <div>
        <div class="wt-field__label">{{ mode === 'weekly' ? 'Ettől a naptól' : 'Nap (vagy kezdete)' }}</div>
        <input type="date" class="wt-field__input" [(ngModel)]="dateFrom">
      </div>
      <div>
        <div class="wt-field__label">{{ mode === 'weekly' ? 'Eddig (opcionális)' : 'Utolsó nap (opcionális)' }}</div>
        <input type="date" class="wt-field__input" [(ngModel)]="dateTo">
      </div>
    </div>

    <label class="wt-plans__check">
      <input type="checkbox" [(ngModel)]="allDay"> Egész nap
    </label>
    <div class="wt-times" *ngIf="!allDay">
      <div>
        <div class="wt-field__label">Távol ettől</div>
        <input type="time" class="wt-field__input" [(ngModel)]="start">
      </div>
      <div>
        <div class="wt-field__label">Eddig</div>
        <input type="time" class="wt-field__input" [(ngModel)]="end">
      </div>
    </div>

    <div class="wt-comment">
      <div class="wt-field__label">Megjegyzés</div>
      <textarea rows="1" placeholder="pl. egyetem" [(ngModel)]="comment"></textarea>
    </div>

    <div class="wt-modal-actions">
      <span class="wt-modal-actions__spacer"></span>
      <button type="button" class="wt-btn-cancel" (click)="formOpen = false">Mégse</button>
      <button type="button" class="wt-btn-save" [disabled]="saving" (click)="save()">Mentés</button>
    </div>
  </div>

  <div class="wt-plans__empty" *ngIf="!plans.length && !formOpen">Nincs előre jelzett távollét.</div>
  <div class="wt-plans__row" *ngFor="let p of plans">
    <span class="wt-pill wt-pill--planned">Távol</span>
    <div class="wt-plans__text">
      <div class="wt-plans__row-title">{{ p.title }}</div>
      <div class="wt-plans__row-sub">{{ p.sub }}</div>
    </div>
    <button type="button" class="wt-plans__del" title="Törlés" (click)="remove(p)">
      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><line x1="6" y1="6" x2="18" y2="18"></line><line x1="18" y1="6" x2="6" y2="18"></line></svg>
    </button>
  </div>
</div>
